<template>
    <div class=" lg:min-h-screen bg-white text-gray-800 font-sans">
        <!-- Hero Header -->
        <section class="relative overflow-hidden  max-h-screen" aria-label="Section de présentation MyProfolia">
            <!-- Background dynamique -->
            <div class="absolute inset-0 z-0">
                <!-- dégradé de base -->
                <div class="absolute inset-0 bg-gradient-to-br from-primary via-primary to-primary-dark opacity-70">
                </div>

                <!-- Effets de lumières -->
                <div class="absolute inset-0 -z-10 overflow-hidden">
                    <!-- Vague 1 -->
                    <div class="absolute w-[120%] h-[120%] top-[-10%] left-[-10%] 
    bg-gradient-to-tr from-primary via-primary-light to-primary-dark 
    rounded-full filter blur-[150px] animate-wave-slow">
                    </div>

                    <!-- Vague 2 -->
                    <div class="absolute w-[130%] h-[130%] top-[-15%] left-[-15%] 
    bg-gradient-to-tr from-red-500 via-fuchsia-500 to-pink-300 
    rounded-full filter blur-[180px] animate-wave-medium">
                    </div>

                    <!-- Vague 3 -->
                    <div class="absolute w-[30%] h-[30%] top-[-5%] left-[-5%] 
    bg-gradient-to-tr from-primary via-indigo-400 to-primary 
    rounded-full filter blur-[120px] animate-wave-fast">
                    </div>

                </div>
            </div>

            <!-- Contenu principal -->
            <div
                class="relative z-10 text-white min-h-screen flex flex-col justify-center px-4 sm:px-6 lg:px-40 pb-16 pt-24 sm:pt-32 sm:pb-32 gap-y-12">

                <!-- Texte principal -->
                <div class="text-left max-w-7xl">
                    <h1
                        class="text-5xl sm:text-5xl md:text-7xl xl:text-7xl 2xl:text-8xl font-extrabold leading-none tracking-tight">
                        Ce qui compte pour votre activité.<br />
                        <span class="block mt-4">Sur une seule page.</span>
                    </h1>

                    <p
                        class="mt-6 text-base sm:text-lg md:text-xl xl:text-xl 2xl:text-2xl text-white font-medium max-w-2xl">
                        Créez votre vitrine en ligne en quelques clics : présente ton entreprise, tes services et
                        tes coordonnées. <br />
                        <span class="font-semibold">Sans aucune compétence technique et sans perte de temps.</span>
                    </p>
                </div>

                <!-- CTA -->
                <div class="flex flex-col xl:flex-row gap-3 xl:gap-4">
                    <!-- Champ URL -->
                    <div
                        class="flex items-center bg-white rounded shadow-md border border-violet-200 px-4 py-3 w-full xl:w-auto">
                        <label class="sr-only" for="slug">Votre URL personnalisée</label>
                        <span class="text-gray-700 whitespace-nowrap text-sm sm:text-base">
                            www.myprofolia.com/
                        </span>
                        <input id="slug" type="text" placeholder="mon-entreprise"
                            class="flex-1 min-w-0 text-gray-700 focus:outline-none text-sm sm:text-base" />
                    </div>

                    <!-- Bouton -->
                    <RouterLink to="/register"
                        class="bg-gray-700 text-white shadow-md px-8 sm:px-6 py-3 rounded hover:bg-gray-300 hover:text-dark transition font-semibold text-center text-base sm:text-lg w-auto self-start whitespace-nowrap">
                        Tester votre site
                    </RouterLink>
                </div>
            </div>
        </section>

        <section class=" py-12 sm:py-24 bg-white overflow-x-hidden">
            <div class="max-w-[90vw] mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">

                <!-- Colonne gauche -->
                <div class="text-left">
                    <span class="text-sm uppercase font-semibold tracking-wider text-primary">
                        Démo
                    </span>
                    <h2 class="text-3xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
                        Découvrez votre vitrine <span class="text-primary"><span class="font-handwritten">my</span>
                            Profolia</span>
                    </h2>
                    <p class="text-lg text-gray-600 mb-10 ">
                        Découvrez à quoi ressemble une page crée avec my
                        Profolia une fois mise en ligne. <br />
                        <span class="hidden md:block">Visualisez une page vitrine professionnelle aussi bien sur
                            <strong>ordinateur</strong> que sur
                            <strong>téléphone</strong>, pour vous projeter facilement dans la façon dont vos clients
                            verront votre vitrine en ligne.</span>
                    </p>

                    <!-- Switch -->
                    <div class="flex gap-4  mx-auto items-center justify-center lg:justify-start">
                        <button @click="preview = 'desktop'" :class="[
                            'px-6 py-2 rounded-lg font-medium flex items-center gap-2 transition',
                            preview === 'desktop'
                                ? 'bg-primary text-white shadow-md'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        ]">
                            💻 <span class="hidden sm:inline">Ordinateur</span>
                        </button>
                        <button @click="preview = 'mobile'" :class="[
                            'px-6 py-2 rounded-lg font-medium flex items-center gap-2 transition',
                            preview === 'mobile'
                                ? 'bg-primary text-white shadow-md'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        ]">
                            📱 <span class="hidden sm:inline">Téléphone</span>
                        </button>
                    </div>
                </div>

                <!-- Colonne droite (aperçu dynamique) -->
                <div class="flex justify-center w-full">
                    <!-- Aperçu DESKTOP -->
                    <Transition name="fade">
                        <div v-show="preview === 'desktop'"
                            class="w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">

                            <!-- Barre Safari -->
                            <div
                                class="flex items-center justify-between bg-gray-100 px-2 sm:px-4 py-2 border-b border-gray-200">
                                <div class="flex items-center space-x-2">
                                    <span class="w-3 h-3 bg-red-400 rounded-full"></span>
                                    <span class="w-3 h-3 bg-yellow-400 rounded-full"></span>
                                    <span class="w-3 h-3 bg-green-400 rounded-full"></span>
                                </div>
                                <div class="flex-1 mx-2 sm:mx-4">
                                    <div
                                        class="bg-white rounded-md border border-gray-300 text-gray-500 text-xs sm:text-sm py-1 px-2 sm:px-3 truncate">
                                        https://myprofolia.com/votrepage
                                    </div>
                                </div>
                                <div class="w-4 sm:w-6"></div>
                            </div>

                            <!-- Capture écran -->
                            <img src="@/assets/demo-capture.png" alt="Exemple MyProfolia ordinateur"
                                class="w-full h-auto object-contain" />
                        </div>
                    </Transition>

                    <!-- Aperçu MOBILE -->
                    <Transition name="fade">
                        <div v-show="preview === 'mobile'"
                            class="relative w-64 sm:w-72 h-[500px] sm:h-[600px] bg-black rounded-[2.5rem] shadow-2xl overflow-hidden border-[12px] border-black">

                            <!-- Vidéo -->
                            <video autoplay loop muted playsinline class="w-full h-full object-cover">
                                <source src="@/assets/video.mp4" type="video/mp4">
                                Votre navigateur ne supporte pas la vidéo.
                            </video>
                        </div>
                    </Transition>
                </div>

            </div>
        </section>


        <!-- Section Pourquoi -->
        <section id="benefices" class="py-16 md:py-32 bg-primary-light">
            <div class="max-w-[90vw] mx-auto px-6 grid lg:grid-cols-3 gap-12 items-start">

                <!-- Colonne gauche : titre -->
                <div class="lg:col-span-1 text-left">
                    <h2 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                        Pourquoi créer votre page vitrine avec
                        <span class="text-violet-500"><span class="font-handwritten">my</span> Profolia</span> ?
                    </h2>
                    <p class="text-lg text-gray-600 mb-2 max-w-md">
                        Plus de visibilité, plus de clients et sans engagement pour <strong>5,99€/mois</strong>
                    </p>

                    <!-- CTA -->
                    <RouterLink to="/register"
                        class="hidden md:inline-block bg-violet-500 hover:bg-violet-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg text-lg transition duration-300 inline-block">
                        Crée ta page gratuitement
                    </RouterLink>
                </div>

                <!-- Colonne droite : cartes -->
                <div class="lg:col-span-2 grid md:grid-cols-2 gap-8">

                    <!-- Attirez plus de clients -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                ✨
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Attirez plus de clients</h3>
                        </div>
                        <p class="text-gray-600">Offrez à votre activité la visibilité qu’elle mérite grâce à une page
                            pro.</p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Booste ta
                            visibilité</span>
                    </div>

                    <!-- Inspirez confiance -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                🤝
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Inspirez confiance</h3>
                        </div>
                        <p class="text-gray-600">Présentez une page professionnelle en ligne claire et rassurante.</p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Renforce ta
                            crédibilité</span>
                    </div>

                    <!-- Gain de temps -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                ⏰
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Gain de temps</h3>
                        </div>
                        <p class="text-gray-600">Remplis notre formulaire simple et ta page est prête à être partagée.
                        </p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Crée ta page en 5
                            minutes</span>
                    </div>

                    <!-- Tout en un -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                📍
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Tout en un seul lien</h3>
                        </div>
                        <p class="text-gray-600">Coordonnées, logo, prestations, avis Google, réseaux sociaux…</p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Centralise ton
                            activité</span>
                    </div>

                    <!-- Sans engagement -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                🕊️
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Sans engagement</h3>
                        </div>
                        <p class="text-gray-600">Vous gardez le contrôle : résiliez ou modifiez en un clic, sans
                            contrainte.</p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Résilie en un
                            clic</span>
                    </div>

                    <!-- Sécurisé et fiable -->
                    <div
                        class="group bg-white rounded-2xl shadow-md p-6 border border-purple-100 hover:border-purple-400 hover:shadow-xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                🔒
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Sécurisé & fiable</h3>
                        </div>
                        <p class="text-gray-600">Votre présence en ligne est protégée et disponible 24h/24, 7j/7.</p>
                        <span class="mt-4 inline-block text-sm font-semibold text-purple-500">☀︎ Maintiens ta présence
                            en ligne</span>
                    </div>
                    <!-- CTA -->
                    <RouterLink to="/register"
                        class="block md:hidden bg-violet-500 hover:bg-violet-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg text-lg transition duration-300 inline-block text-center">
                        Crée ta page gratuitement
                    </RouterLink>
                </div>
            </div>
        </section>

        <section class="bg-white py-16">
            <div class="max-w-5xl mx-auto px-6 flex flex-col gap-10">

                <!-- Titre section -->
                <div class="text-left px-2 md:text-center">
                    <h2 class="text-3xl md:text-4xl font-bold text-gray-900">
                        Comment fonctionne <span class="text-violet-500"><span class="font-handwritten">my</span>
                            Profolia</span> ?
                    </h2>
                    <p class="text-gray-600 mt-2 text-lg">
                        Suivez ces étapes simples pour créer votre page professionnelle.
                    </p>
                </div>

                <!-- Stepper -->
                <div class="bg-white shadow-lg rounded-2xl p-8">
                    <div class="flex items-center justify-between relative">
                        <div v-for="(step, index) in steps" :key="index"
                            class="flex-1 flex flex-col items-center relative">

                            <!-- Cercle -->
                            <button @click="currentStep = index" class="w-12 h-12 flex items-center justify-center rounded-full z-10 font-bold
                   transition-colors duration-300" :class="currentStep >= index
                    ? 'bg-violet-600 text-white shadow-lg ring-4 ring-violet-200'
                    : 'bg-gray-200 text-gray-600 hover:bg-violet-100'">
                                {{ index + 1 }}
                            </button>

                            <!-- Trait de liaison -->
                            <div v-if="index < steps.length - 1"
                                class="absolute top-1/2 left-1/2 w-full h-1 -translate-y-1/2"
                                :class="currentStep > index ? 'bg-violet-400' : 'bg-gray-200'"></div>
                        </div>
                    </div>

                    <!-- Card contenu -->
                    <div class="py-8 text-center">
                        <h3 class="text-2xl font-bold text-violet-600 mb-3">
                            {{ steps[currentStep].title }}
                        </h3>
                        <p class="text-gray-600 text-lg">
                            {{ steps[currentStep].description }}
                        </p>
                        <!-- Bouton Commencer -->
                        <RouterLink to="/register"
                            class="inline-block mt-8 bg-violet-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-violet-700 transition font-semibold">
                            Créer mon compte
                        </RouterLink>
                    </div>
                </div>

            </div>
        </section>

        <!-- Section Pour Qui -->
        <section id="pour-qui" class="py-20 bg-primary-light">
            <div class="max-w-[90vw] mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">

                <!-- Colonne gauche -->
                <div class="text-left">
                    <!-- Titre -->
                    <h2 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                        À qui s’adresse
                        <span class="text-violet-500">
                            <span class="font-handwritten">my</span> Profolia
                            <span class="text-gray-800"> ?</span>
                        </span>
                    </h2>

                    <!-- Sous-texte -->
                    <p class="text-lg text-gray-600 mb-2 max-w-md">
                        Un <strong>site vitrine professionnel</strong>, simple à créer, pensé pour tous les métiers qui
                        veulent être visibles en ligne.
                    </p>

                    <!-- Phrase finale -->
                    <p class="text-lg text-gray-600 md:mb-10 max-w-md">
                        Peu importe ton domaine, ta page professionnelle est prête en quelques minutes.
                        <span class="block">Simple, efficace et conçue pour te rendre visible.</span>
                    </p>

                    <!-- CTA -->
                    <RouterLink to="/register"
                        class="hidden md:inline-block bg-primary hover:bg-primary-dark text-white font-semibold py-4 px-8 rounded-lg mx-auto shadow-md text-lg transition">
                        Crée ta page gratuitement
                    </RouterLink>
                </div>

                <!-- Colonne droite (cartes métiers) -->
                <div class="grid sm:grid-cols-2 gap-8">

                    <!-- Artisans -->
                    <div
                        class="group bg-white rounded-2xl shadow-lg p-6 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-100 text-primary text-2xl group-hover:bg-purple-600 group-hover:text-white transition">
                                🔧
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Artisans</h3>
                        </div>
                        <p class="text-gray-600 mb-4">Plombier, maçon, peintre, électricien, menuisier…</p>
                        <span
                            class="inline-block text-sm font-semibold text-purple-600 group-hover:text-primary transition">
                            👉 Crée ton site en 5 minutes
                        </span>
                    </div>

                    <!-- Bien-être -->
                    <div
                        class="group bg-white rounded-2xl shadow-lg p-6 border border-green-100 hover:border-green-400 hover:shadow-2xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-green-100 text-green-600 text-2xl group-hover:bg-green-500 group-hover:text-white transition">
                                🌿
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Bien-être</h3>
                        </div>
                        <p class="text-gray-600 mb-4">Masseuse, kiné, esthéticienne, coach sportif, sophrologue…</p>
                        <span
                            class="inline-block text-sm font-semibold text-green-600 group-hover:text-green-700 transition">
                            🌟 Attire plus de clients en ligne
                        </span>
                    </div>

                    <!-- Créatifs & indépendants -->
                    <div
                        class="group bg-white rounded-2xl shadow-lg p-6 border border-pink-100 hover:border-pink-400 hover:shadow-2xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <!-- Fix cercle parfait -->
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-pink-100 text-pink-600 text-2xl group-hover:bg-pink-500 group-hover:text-white transition">
                                🎨
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Créatifs </h3>
                        </div>
                        <p class="text-gray-600 mb-4">Tatoueur, photographe, graphiste, consultant…</p>
                        <span
                            class="inline-block text-sm font-semibold text-pink-600 group-hover:text-pink-700 transition">
                            🚀 Mets en valeur ton savoir-faire
                        </span>
                    </div>

                    <!-- Services -->
                    <div
                        class="group bg-white rounded-2xl shadow-lg p-6 border border-blue-100 hover:border-blue-400 hover:shadow-2xl transition transform hover:-translate-y-2">
                        <div class="flex items-center gap-4 mb-3">
                            <div
                                class="flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 text-blue-600 text-2xl group-hover:bg-blue-500 group-hover:text-white transition">
                                🛍️
                            </div>
                            <h3 class="text-xl font-bold text-gray-800">Services</h3>
                        </div>
                        <p class="text-gray-600 mb-4">Coiffeur, ménage à domicile, cours particuliers…
                        </p>
                        <span
                            class="inline-block text-sm font-semibold text-blue-600 group-hover:text-blue-700 transition">
                            💼 Développe ta clientèle locale
                        </span>
                    </div>
                    <RouterLink to="/register"
                        class="block md:hidden inline-block bg-primary hover:bg-primary-dark text-white font-semibold py-4 px-8 rounded-lg mx-auto shadow-md text-lg transition">
                        Crée ta page gratuitement
                    </RouterLink>
                </div>

            </div>
        </section>


        <!-- Tarifs -->
        <section
            class="min-h-[70vh] relative flex flex-col items-center justify-center px-4 py-12 overflow-hidden bg-white">


            <div
                class="bg-white backdrop-blur-md rounded-3xl shadow-lg max-w-4xl w-full p-8  flex flex-col items-center gap-6 text-center ">

                <!-- Titre -->
                <h2 class="text-3xl md:text-4xl font-bold text-black ">
                    Votre abonnement <span class="text-violet-500"><span class="font-handwritten">my</span>
                        Profolia</span>
                </h2>

                <!-- Description -->
                <p class="text-lg text-gray-600">
                    Tout ce dont vous avez besoin pour être visible en ligne
                </p>

                <!-- Tarifs horizontaux -->
                <div
                    class="flex flex-col md:flex-row items-center justify-center gap-12 bg-purple-50 p-6 rounded-2xl shadow-inner w-full">
                    <div class="flex flex-col md:flex-row items-center justify-center gap-8">

                        <!-- Mensuel -->
                        <div class="text-center">
                            <p class="text-2xl font-bold text-primary">5,99 € / mois</p>
                            <p class="text-gray-600">Sans engagement</p>
                        </div>

                        <!-- OU -->
                        <div class="font-semibold text-lg text-gray-500">OU</div>

                        <!-- Annuel -->
                        <div class="text-center">
                            <p class="text-2xl font-bold text-primary">59,99 € / an</p>
                            <p class="text-gray-600">Engagement 12 mois</p>
                        </div>

                    </div>
                </div>


                <!-- Features / Avantages avec cards -->
                <div class="grid md:grid-cols-2 gap-4 w-full">

                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                🪪
                            </div>
                            <h3 class="font-semibold text-lg">Identité professionnelle</h3>
                        </div>
                        <p class="text-gray-600 text-sm">Mets en avant ton entreprise, ton activité et ton savoir-faire.
                        </p>
                    </div>

                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                📋
                            </div>
                            <h3 class="font-semibold text-lg">Prestations & Tarifs</h3>
                        </div>
                        <p class="text-gray-600 text-sm">Présente tes services et facilite la prise de rendez-vous.</p>
                    </div>

                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                📞
                            </div>
                            <h3 class="font-semibold text-lg">Contact</h3>
                        </div>
                        <p class="text-gray-600 text-sm">Téléphone, WhatsApp ou Email : tes clients te contactent
                            facilement.</p>
                    </div>

                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                📍
                            </div>
                            <h3 class="font-semibold text-lg">Adresse & Horaires</h3>
                        </div>
                        <p class="text-gray-600 text-sm">
                            Indique ton adresse et tes horaires pour informer tes clients.
                        </p>
                    </div>

                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                ⭐
                            </div>
                            <h3 class="font-semibold text-lg">Avis Google</h3>
                        </div>
                        <p class="text-gray-600 text-sm">Valorise ta réputation et rassure tes futurs clients.</p>
                    </div>


                    <div
                        class="group bg-white rounded-2xl shadow-lg p-4 border border-purple-100 hover:border-purple-400 hover:shadow-2xl transition transform hover:-translate-y-2 text-left">
                        <div class="flex items-center gap-3 mb-2">
                            <div
                                class="flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-500 text-2xl group-hover:bg-purple-500 group-hover:text-white transition">
                                📱
                            </div>
                            <h3 class="font-semibold text-lg">Réseaux sociaux</h3>
                        </div>
                        <p class="text-gray-600 text-sm">Facebook, Instagram, LinkedIn… renforce ta présence en ligne.
                        </p>
                    </div>

                </div>

                <!-- CTA -->
                <div class="text-center mt-6">
                    <RouterLink to="/register"
                        class="bg-primary hover:bg-primary-dark text-white font-bold py-4 px-4 md:px-10 rounded-lg shadow-lg text-lg transition duration-300 inline-block">
                        Crée ta page gratuitement
                    </RouterLink>
                </div>
            </div>
        </section>


        <section id="demo" class="bg-primary-light py-16">
            <div class="max-w-4xl mx-auto px-6 flex flex-col items-center text-center">

                <!-- Titre -->
                <h3 class="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-12">
                    Réserve ton URL <br /><span class="text-primary"><span class="font-handwritten">my</span>
                        Profolia</span>
                </h3>

                <!-- Champ + Bouton -->
                <div class="w-full flex flex-col xl:flex-row items-stretch gap-4">

                    <!-- Champ URL -->
                    <div
                        class="flex items-center bg-white rounded-lg shadow-lg border border-violet-200 px-4 py-3 w-full">
                        <label class="sr-only" for="slug">Votre URL personnalisée</label>
                        <span class="text-gray-700 font-mono whitespace-nowrap text-sm sm:text-base">
                            www.myprofolia.com/
                        </span>
                        <input id="slug" type="text" placeholder="mon-entreprise"
                            class="flex-1 min-w-0 font-mono text-gray-800 focus:outline-none text-sm sm:text-base pl-2" />
                    </div>

                    <!-- Bouton -->
                    <RouterLink to="/register"
                        class="bg-primary text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-primary-dark transition text-base sm:text-lg flex items-center justify-center whitespace-nowrap">
                        Réserver
                    </RouterLink>
                </div>
            </div>
        </section>


    </div>
</template>

<script setup>
import { ref } from 'vue'
const preview = ref('mobile') // valeur par défaut

const currentStep = ref(0)

const steps = ref([
    {
        title: "Crée un compte gratuitement",
        description: "En quelques clics seulement, tu peux créer ton compte sans frais. Pas besoin de carte bancaire pour commencer, tu accèdes immédiatement à ton espace personnel."
    },
    {
        title: "Remplis le formulaire",
        description: "Ajoute les informations essentielles de ton entreprise : ton logo, ta description, tes services et tes coordonnées. C’est rapide et tu gardes le contrôle à chaque étape."
    },
    {
        title: "Prévisualise ta page",
        description: "Découvre instantanément à quoi ressemblera ta vitrine professionnelle en ligne. Tu peux modifier le contenu en temps réel jusqu’à ce que le rendu te convienne parfaitement."
    },
    {
        title: "Choisis ton abonnement",
        description: "Opte pour la formule qui te correspond le mieux : mensuelle pour plus de flexibilité, ou annuelle pour bénéficier d’un tarif avantageux. Tu ne paies que lorsque tu décides de publier."
    },
    {
        title: "Publie ta page en ligne",
        description: "En un clic, mets ton site vitrine en ligne et rends ton activité visible sur le web. Partage ton lien avec tes clients et commence à développer ta présence en ligne immédiatement."
    },
])

</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}


/* Animations pour le bg du hero */

@keyframes wave-slow {
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }

    20% {
        transform: translate(-30%, 10%) scale(1.1) rotate(8deg);
    }

    40% {
        transform: translate(25%, -20%) scale(1.05) rotate(-6deg);
    }

    60% {
        transform: translate(-15%, 15%) scale(1.12) rotate(12deg);
    }

    80% {
        transform: translate(20%, 5%) scale(1.08) rotate(-4deg);
    }

    100% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }
}

@keyframes wave-medium {
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }

    20% {
        transform: translate(20%, -15%) scale(1.08) rotate(-10deg);
    }

    40% {
        transform: translate(-25%, 25%) scale(1.05) rotate(15deg);
    }

    60% {
        transform: translate(15%, -10%) scale(1.1) rotate(-8deg);
    }

    80% {
        transform: translate(-10%, 20%) scale(1.07) rotate(6deg);
    }

    100% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }
}

@keyframes wave-fast {
    0% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }

    20% {
        transform: translate(-20%, 25%) scale(1.12) rotate(18deg);
    }

    40% {
        transform: translate(30%, -15%) scale(1.05) rotate(-12deg);
    }

    60% {
        transform: translate(-15%, 10%) scale(1.1) rotate(15deg);
    }

    80% {
        transform: translate(25%, -20%) scale(1.08) rotate(-10deg);
    }

    100% {
        transform: translate(0, 0) scale(1) rotate(0deg);
    }
}

.animate-wave-slow {
    animation: wave-slow 35s ease-in-out infinite;
}

.animate-wave-medium {
    animation: wave-medium 25s ease-in-out infinite;
}

.animate-wave-fast {
    animation: wave-fast 18s ease-in-out infinite;
}





.hand-arrow .frame {
    display: none;
    transform-origin: center;
}

.hand-arrow .frame1 {
    animation: animateArrow 1s steps(3) infinite;
}

.hand-arrow .frame2 {
    animation: animateArrow 1s steps(3) infinite;
}

.hand-arrow .frame3 {
    animation: animateArrow 1s steps(3) infinite;
}

@keyframes animateArrow {
    0% {
        display: block;
    }

    33% {
        display: none;
    }

    66% {
        display: none;
    }

    100% {
        display: block;
    }
}
</style>
